import { Module } from './Module';

export enum ActionType {
	request = 'PriceReferencing.request',
	receive = 'PriceReferencing.receive',
	prune = 'PriceReferencing.prune',
}

interface RequestAction {
	type: ActionType.request;
	request: Promise<{ items: { id: string }[] }>;
	module: Module;
}

interface ReceiveAction {
	type: ActionType.receive;
	request: Promise<{ items: { id: string }[] }>;
	versions: { id: string }[] | null;
}

interface PruneAction {
	type: ActionType.prune;
}

export type Action = RequestAction | ReceiveAction | PruneAction;
